import { Bot, CheckCircle } from "@/components/icons"
import { Badge } from "@/components/ui/badge"
import { Card, CardContent } from "@/components/ui/card"

export function DemoGenerationCompleted() {
  return (
    <Card className="w-full overflow-hidden sm:max-w-xs">
      <div className="relative aspect-video w-full bg-gradient-to-br from-slate-700 via-slate-800 to-slate-900">
        <div className="flex h-full items-center justify-center">
          <Bot className="h-16 w-16 text-slate-500" />
        </div>
        <div className="absolute top-2 right-2">
          <Badge className="bg-success text-success-foreground border-foreground hover:bg-success border">
            <CheckCircle className="mr-1 h-3 w-3" />
            Completed
          </Badge>
        </div>
      </div>
      <CardContent className="p-4">
        <p className="mb-3 line-clamp-2 text-sm">
          a tiny little robot, dancing on the keyboard of a large laptop...
        </p>
        <div className="flex flex-wrap gap-2">
          <Badge className="text-xs" variant="outline">
            4s
          </Badge>
          <Badge className="text-xs" variant="outline">
            16:9
          </Badge>
          <Badge className="text-xs" variant="outline">
            realistic
          </Badge>
        </div>
      </CardContent>
    </Card>
  )
}
